import { Component, OnInit } from '@angular/core';
import * as _ from 'underscore';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/observable/forkJoin';
import * as Collections from 'typescript-collections';
import { SharedService } from '../../shared.service';
import { CookieService } from 'ngx-cookie';
import { UserPreferenceService } from '../services/user.preferences.service';
import { EcareConfigurationService } from '../services/ecareconfiguration.service';
import { DeviceService } from '../services/device.service';
import { DataStreamService } from '../services/datastream.service';
import { UserService } from '../services/user.service';
import { delay } from 'rxjs/operators';

@Component({
    selector: 'app-sensordatacomponent',
    template: 'Nothing',
})
export class SensordataComponent implements OnInit {
    preferences = {};
    uiConfiguration: any;
    users = [];
    dataStreams: any = [];
    devices = [];
    deviceId = '';
    labels = [];
    uiUOM = {
    };
    loginUser: any;
    currentUser: any;
    dataLoaded = false;
    pageData: any;
    chartOrderModel = {};
    hasStreamsToDisplay = false;
    hasDisabledStreamsToDisplay = false;

    settings = {
        chart: {},
        order: {},
        nomovedown: {},
        nomoveup: {},
        export: {},
    };

    constructor(private pagedata: SharedService
        , private cookieService: CookieService
        , protected userPreferences: UserPreferenceService
        , private configurationService: EcareConfigurationService
        , private dataStreamService: DataStreamService
        , private userService: UserService
        , private deviceService: DeviceService
        , private sharedService: SharedService) {
        this.currentUser = JSON.parse(localStorage.getItem('user'));
        const selectedUser = this.pagedata.get('sensor-data').selectedUser;
        if (selectedUser) {
            this.currentUser = selectedUser;
        }
    }

    getCampaignDevices(campaignId){
        return this.deviceService.getCampaignDevices(campaignId);
    }

    getADevice(id){
        return this.deviceService.getOne(id);
    }

    ngOnInit() {}

    /*  Initial data load for live data */
    loadData(campaignId: any, deviceId: any) {
        if (!this.currentUser) {
            return;
        }
        this.dataLoaded = false;
        try {
            this.getConfData(campaignId, deviceId).then(responseList => {
                this.preferences = responseList[0];
                this.dataStreams = responseList[1];
                this.uiUOM['TEMPERATURE'] = responseList[2] || '°C';
                this.devices = responseList[3];
                this.uiConfiguration = responseList[4];
                this.isDeviceId('');
                // Initialize settings
                setTimeout(() => {
                    this.initSettings();
                }, 10000);

                this.dataLoaded = true;
            });
        } catch (Error) {
            console.error('Resetting data due to error.' + Error);
            this.preferences = {};
            this.uiConfiguration = {};
            this.currentUser = null;
            this.devices = [];
            this.dataStreams = [];
            this.uiUOM['TEMPERATURE'] = '';
            this.dataLoaded = false;
        } finally {
        }
    }

    getConfData(campaignId: any, deviceId: any) {
        const url1 = this.userPreferences.get('sensorData/*', this.currentUser);
        const url5 = this.configurationService.getConfiguration('sensorData/*');
        const url4 = this.deviceService.getCampaignDevices(campaignId);
        const url2 = this.dataStreamService.getCampaignDataStreamsByDeviceId(campaignId, deviceId);
        const url3 =  this.userPreferences.getForLoggedUser('units_measurement_temperature', this.currentUser.id);
        return Observable.forkJoin([url1, url2, url3, url4, url5]).toPromise();
    }


    initSettings() {
        this.settings.chart = {};
        this.settings.export = {};
        let persons =  this.uiConfiguration.find(x => x.id === 'sensorData/chart/scale');
        this.settings.chart['zoom'] = this.uiConfiguration['sensorData/chart/zoom']
            || parseFloat(this.preferences['sensorData/chart/zoom']);

        let scalePref = this.preferences['sensorData/chart/scale'];
        if( scalePref !== undefined) {
            this.settings.chart['scale'] = parseFloat(this.preferences['sensorData/chart/scale'])
                || this.uiConfiguration['sensorData/chart/scale'].defaultValue;
        } else {
            this.settings.chart['scale'] = this.uiConfiguration.find(x => x.id === 'sensorData/chart/scale').defaultValue;
        }

        let speedPref = this.preferences['sensorData/chart/speed'];
        if (speedPref !== undefined) {
            this.settings.chart['speed'] = parseFloat(this.preferences['sensorData/chart/speed'])
                || this.uiConfiguration['sensorData/chart/speed'].defaultValue;
        } else {
            this.settings.chart['speed'] = this.uiConfiguration.find(x => x.id === 'sensorData/chart/speed').defaultValue;
        }

        let timeRangePref = this.preferences['sensorData/chart/timeRange'];
        if (timeRangePref !== undefined) {
            this.settings.chart['timeRange'] = parseFloat(this.preferences['sensorData/chart/timeRange'])
                || this.uiConfiguration['sensorData/chart/timeRange'].defaultValue;
        } else {
            this.settings.chart['timeRange'] = this.uiConfiguration.find(x => x.id === 'sensorData/chart/timeRange').defaultValue;
        }

        let showAmpPref = this.preferences['sensorData/chart/showAmplitude'];
        if (showAmpPref !== undefined){
            this.settings.chart['showAmplitude'] = parseFloat(this.preferences['sensorData/chart/showAmplitude'])
                || this.uiConfiguration.find(x => x.id === 'sensorData/chart/showAmplitude').defaultValue;
        } else {
            this.settings.chart['showAmplitude'] = this.uiConfiguration.find(x => x.id === 'sensorData/chart/showAmplitude').defaultValue;
        }
        // ForEach loop is much slower than old for loop
        for (let i = 0, len = this.dataStreams.length; i < len; i++) {
            const dataStream = this.dataStreams[i];
            const displayPref = this.preferences['sensorData/chart/' + dataStream.id + '/display'];
            const display = (displayPref === undefined || displayPref === 'true');

            const chartTypePref = this.preferences['sensorData/chart/' + dataStream.id + '/type'];
            const chartType = (chartTypePref !== undefined)
                ? chartTypePref
                : this.resolveUiConfig('sensorData/chart/' +
                    dataStream.dataStreamType.category + '/type');
            const timeRangePref = this.preferences['sensorData/chart/' + dataStream.id + '/timeRange'];
            const timeRange = (timeRangePref !== undefined)
                ? parseFloat(timeRangePref)
                : this.resolveUiConfig('sensorData/chart/' +
                    dataStream.dataStreamType.category + '/timeRange')
            ;
            const showValue = this.resolveUiConfig('sensorData/chart/' +
                dataStream.dataStreamType.category + '/showValue');

            const numberFormat = this.resolveUiConfig('sensorData/chart/' +
                dataStream.dataStreamType.category + '/numberFormat');

            const currentValueTpl = this.resolveUiConfig('sensorData/chart/' +
                dataStream.dataStreamType.category + '/currentValueTpl');

            let channelConfig;
            if (this.resolveUiConfig('sensorData/' + dataStream.dataStreamType.category + '/channels')) {
                channelConfig = this.resolveUiConfig('sensorData/' +
                    dataStream.dataStreamType.category + '/channels');
            }

            this.labels[dataStream.dataStreamType.category] = this.resolveUiConfig('sensorData/dataStream/' +
                dataStream.dataStreamType.category + '/displayName');
            const deviceDeactivated = this.resolveDevice(dataStream.deviceId);
            this.settings.chart[dataStream.id] = {
                selected: display ? !deviceDeactivated.deactivated : false,
                enabled: dataStream.enabled,
                chartType: chartType,
                timeRange: timeRange,
                showValue: showValue,
                numberFormat: numberFormat,
                currentValueTpl: currentValueTpl,
                channels: channelConfig || [],
                fullscreen: false
            };
            const exportSelectionPref = this.preferences['sensorData/export/' + dataStream.id + '/selected'];
            const exportSelection = (displayPref === undefined || displayPref === 'true');
            this.settings.export[dataStream.id] = {
                selected: exportSelection
            };
        }
        this.initChartOrderSettings();
        this.hasStreamsToDisplay = this.streamsToDisplay();
        this.hasDisabledStreamsToDisplay = this.disabledStreamsToDisplay();
    }

    streamsToDisplay() {
        let toDisplay = false;
        this.dataStreams.forEach(dataStream => {
            const device = this.resolveDevice(dataStream.deviceId);
            const deviceDeactivated = device ? device['deactivated'] : true;
            if (dataStream.enabled && !deviceDeactivated) {
                toDisplay = true;
                return;
            }
        });
        return toDisplay;
    }

    disabledStreamsToDisplay() {
        let selected = false;
        this.dataStreams.forEach(dataStream => {
            if (this.settings.chart[dataStream.id].selected) {
                selected = true;
            }
        });
        return selected;
    }

    initChartOrderSettings() {
        this.settings.order = {};
        for (const [key, value] of Object.entries(this.preferences)) {
            const match = key.match(/sensorData\/chart\/(.*)\/order/);
            if (match && match.length > 1) {
                const streamId = match[1];
                this.settings.order['streamId'] = value;
            }
        }

        // this.chartOrderModel = {};
        this.devices.forEach(device  =>  {
            this.chartOrderModel[device.id] = '';
        });
        this.dataStreams.forEach(dataStream => {
            this.chartOrderModel[dataStream.deviceId] = dataStream.id;
        });

        // this.devices.forEach(device => {
        //    this.chartOrderModel[device.id].sort(function (dataStreamId1, dataStreamId2) {
        //         var order1 = this.settings.order[dataStreamId1];
        //         var order2 = this.settings.order[dataStreamId2];
        //         return order1 - order2;
        //     });
        //
        // });
        // _.values(this.chartOrderModel).sort((a,b)=>a.id> b.id);



        this.settings.nomoveup = {};
        this.settings.nomovedown = {};
        let firstVisible = '';
        let lastVisible = '';

        this.devices.forEach(device => {
            const dataStreamId = this.chartOrderModel[device.id];
            const index = 0;
            this.settings.order[dataStreamId] = index;
            if (index === 0) {
                this.settings.nomoveup[dataStreamId] = 1;
            }
            if (this.settings.chart[dataStreamId] && this.settings.chart[dataStreamId].enabled &&
                this.settings.chart[dataStreamId].selected) {
                if (firstVisible === '') {
                    firstVisible = dataStreamId;
                }
                lastVisible = dataStreamId;
            }
        });

        if (lastVisible !== '') {
            this.settings.nomoveup[firstVisible] = 1;
            this.settings.nomovedown[lastVisible] = 1;
        }


    }

    resolveUiConfig(id: string) {
        return  _.find(this.uiConfiguration, function(config) {
            if (config['id'] === id) {
                return config['defaultValue'];
            }
        });
    }

    resolveDevice(deviceId) {
        return _.find(this.devices, function (device) {
            if ( deviceId === device['id']) {
                return device;
            }
        });
    }

    /* Check for deactivated device id*/
    isDeviceId(deviceId) {
        if ((deviceId === '') && this.devices.length >= 1) {
            for (let i = 0; i < this.devices.length; i++) {
                if (!this.devices[i].deactivated) {
                    this.deviceId = this.devices[i].id;
                    break;
                }
            }
        }
        return this.deviceId === deviceId;
    }
}
